import Home from '../Pages/Home';
// import Settings from '../Pages/Settings';
import Department from '../Pages/Department';
import Post from '../Pages/Post';
import Employee from '../Pages/Employee';
import Assets from '../Pages/Assets';
import AssetsList from '../Pages/AssetsList';
import Shift from '../Pages/Shift';
import Reports from '../Pages/Reports';
import DutyRoster from '../Pages/DutyRoster/index';
import DutyRosterCreate from '../Pages/DutyRoster/DutyRosterCreate';
import DutyRosterUpdate from '../Pages/DutyRoster/DutyRosterUpdate';

const routes = [
    { Navigation: '/', exact: true, component: Home },
    // { Navigation: '/settings', exact: true, component: Settings },
    { Navigation: '/home', exact: true, component: Home },
    { Navigation: '/department', component: Department},
    { Navigation: '/post', component: Post},
    { Navigation: '/employee', component: Employee},
    { Navigation: '/assets', component: Assets},
    { Navigation: '/asset-list', component: AssetsList},
    { Navigation: '/shift', component: Shift},
    { Navigation: '/duty-roster', component: DutyRoster},
    { Navigation: '/duty-roster-create', component: DutyRosterCreate},
    { Navigation: '/duty-roster-update', component: DutyRosterUpdate},
    { Navigation: '/Reports', component: Reports},
]

export default routes;